import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTranslations, useLanguage } from "@vocab/react";
import { Box, Stack, Heading, Inline, Rating, Text, TextLink, IconCompany, IconPeople, IconPromote, Actions, ButtonLink, IconArrow, IconLocation, IconTime, IconMoney, ButtonIcon, IconInfo, Dialog, TooltipRenderer, IconRecommended, IconTick, IconCritical, HiddenVisually, Notice, Hidden, Disclosure, TextField, Dropdown, Textarea, Button, Alert, Tiles, List } from "braid-design-system";
import { breakpoints } from "braid-design-system/css";
import { useInView } from "react-intersection-observer";
import { useCallback, createContext, useContext, useState, useMemo, useEffect, Fragment as Fragment$1, useRef } from "react";
import { translations as translations$3 } from "../../../components/.vocab/index.mjs";
import { ApplyButton } from "../ApplyButton/ApplyButton.mjs";
import { ReadMore } from "@seek/profile-read-ui";
import { translations } from "../../../components/CompanyProfile/.vocab/index.mjs";
import { JDVLayout } from "../JDVLayout/JDVLayout.mjs";
import { templateRenderer, toCISImpression, iterateOverContactMatches } from "@seek/candidate-interest-signals";
import { UnsafeJobHtmlRenderer } from "@seek/job-html-renderer";
import { JobDetailsViewHeader } from "../JobDetailsViewHeader/JobDetailsViewHeader.mjs";
import { translations as translations$1 } from "../../../components/JobDetailsViewHeaderAdditional/.vocab/index.mjs";
import { translations as translations$2 } from "../../../components/JobStatusBadge/.vocab/index.mjs";
import { createForm, useField } from "@seek/forms-ui";
import { useMelwaysLink } from "@seek/melways-react";
import { isEmail, maxLength } from "@seek/validators-js";
import { ResponsiveEmbed } from "../ResponsiveEmbed/ResponsiveEmbed.mjs";
import { ShareMenu } from "../ShareMenu/ShareMenu.mjs";
import { sourcrImage } from "./JobDetailsView.css.mjs";
const useAnalyticsHandlers = (track) => {
  const onCompanyJobSearchClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_JOB_SEARCH_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onCompanyProfileClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_PROFILE_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onCompanyProfileWidgetImpression = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_IMPRESSION"
    });
  }, [track]);
  const onCompanyProfileWidgetAccordionClick = useCallback(
    (showMore) => {
      track({
        type: "COMPANY_PROFILE_WIDGET_ACCORDION_LINK_CLICK",
        linkAction: showMore ? "expand" : "collapsed"
      });
    },
    [track]
  );
  const onCompanyProfileWidgetClick = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_LINK_CLICK",
      linkPosition: "below"
    });
  }, [track]);
  const onCompanyProfileWidgetReviewsClick = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_REVIEWS_LINK_CLICK",
      linkPosition: "below"
    });
  }, [track]);
  const onCompanyReviewsClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_REVIEWS_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onContactMatchImpression = useCallback(
    (payload) => {
      track({
        type: "CONTACT_MATCH_IMPRESSION",
        contactTypes: payload
      });
    },
    [track]
  );
  const onContactMatchInteraction = useCallback(
    ({ eventType, contactType }) => {
      track({
        type: "CONTACT_MATCH_INTERACTION",
        contactType,
        eventType
      });
    },
    [track]
  );
  const onJobTitleClick = useCallback(
    (evt) => {
      track({
        type: "JOB_TITLE_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onShareEmailClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "email"
    });
  }, [track]);
  const onShareFacebookClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "facebook"
    });
  }, [track]);
  const onShareLinkedInClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "linkedin"
    });
  }, [track]);
  const onShareTwitterClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "twitter"
    });
  }, [track]);
  const onTopApplicantBadgeClick = useCallback(() => {
    track({
      type: "TOP_APPLICANT_BADGE_CLICK"
    });
  }, [track]);
  const onTopApplicantBadgeImpression = useCallback(() => {
    track({
      type: "TOP_APPLICANT_BADGE_IMPRESSION"
    });
  }, [track]);
  const onSourcrImpression = useCallback(() => {
    track({
      type: "SOURCR_IMPRESSION"
    });
  }, [track]);
  const onSourcrClicked = useCallback(() => {
    track({
      type: "SOURCR_CLICKED"
    });
  }, [track]);
  const onSalaryBadgeClicked = useCallback(() => {
    track({
      type: "SALARY_BADGE_CLICKED"
    });
  }, [track]);
  return {
    onCompanyJobSearchClick,
    onCompanyProfileClick,
    onCompanyProfileWidgetImpression,
    onCompanyProfileWidgetAccordionClick,
    onCompanyProfileWidgetClick,
    onCompanyProfileWidgetReviewsClick,
    onCompanyReviewsClick,
    onContactMatchImpression,
    onContactMatchInteraction,
    onJobTitleClick,
    onShareEmailClick,
    onShareFacebookClick,
    onShareLinkedInClick,
    onShareTwitterClick,
    onTopApplicantBadgeClick,
    onTopApplicantBadgeImpression,
    onSourcrImpression,
    onSourcrClicked,
    onSalaryBadgeClicked
  };
};
const initialState = {};
const JobDetailsViewContext = createContext(initialState);
const noop$1 = () => {
};
const useJobDetailsViewContext = () => {
  const {
    onAnalyticsEvent = noop$1,
    shouldOpenApplyInNewTab = false,
    stickApplyButtonOnDesktop = false,
    displayCompanyProfile = false,
    ...result
  } = useContext(JobDetailsViewContext);
  return {
    ...result,
    onAnalyticsEvent,
    shouldOpenApplyInNewTab,
    stickApplyButtonOnDesktop,
    displayCompanyProfile
  };
};
const JobDetailsViewContextProvider = ({
  children,
  ...props
}) => /* @__PURE__ */ jsx(JobDetailsViewContext.Provider, { value: { ...props }, children });
const LOGO_MAX_HEIGHT = 50;
const CompanyProfile = (company) => {
  const {
    logo,
    profileUrl,
    reviewsUrl,
    name,
    onAnalyticsEvent = () => {
    },
    overview,
    perksAndBenefits = [],
    overallRating,
    shouldDisplayReviews = false
  } = company;
  const industry = overview == null ? void 0 : overview.industry;
  const companySize = overview == null ? void 0 : overview.companySize;
  const companyDescription = (overview == null ? void 0 : overview.companyDescription) ?? [];
  const { t } = useTranslations(translations);
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  const { ref: trackedComponent } = useInView({
    onChange(inView) {
      if (inView) {
        analytics.onCompanyProfileWidgetImpression();
      }
    },
    threshold: 0.5,
    triggerOnce: true
  });
  const showProfile = company && name && profileUrl;
  return showProfile && /* @__PURE__ */ jsx(Box, { ref: trackedComponent, children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    /* @__PURE__ */ jsx(Heading, { level: "3", children: t("Company profile") }),
    /* @__PURE__ */ jsxs(
      Box,
      {
        borderRadius: "xlarge",
        boxShadow: "borderNeutralLight",
        data: { automation: "company-profile" },
        padding: "large",
        children: [
          /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
            /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsx(Stack, { space: "medium", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
              Boolean(logo) && /* @__PURE__ */ jsx(Box, { display: "flex", height: "full", children: /* @__PURE__ */ jsx(
                Box,
                {
                  component: "img",
                  src: logo,
                  alt: `Company Logo for ${name}`,
                  style: {
                    maxHeight: LOGO_MAX_HEIGHT
                  }
                }
              ) }),
              /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
                Boolean(name) && /* @__PURE__ */ jsx(Heading, { level: "4", children: name }),
                shouldDisplayReviews && overallRating && overallRating.rating > 0 && overallRating.reviewCount > 0 && Boolean(reviewsUrl) && /* @__PURE__ */ jsxs(
                  Inline,
                  {
                    space: "xxsmall",
                    alignY: "bottom",
                    data: { automation: "company-profile-review" },
                    children: [
                      /* @__PURE__ */ jsx(
                        Rating,
                        {
                          rating: overallRating.rating,
                          variant: "minimal",
                          data: {
                            automation: "company-profile-review-rating"
                          }
                        }
                      ),
                      reviewsUrl != null && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(Text, { children: "·" }),
                        /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            href: reviewsUrl,
                            rel: "nofollow",
                            weight: "weak",
                            data: {
                              automation: "company-profile-review-link"
                            },
                            onClick: analytics.onCompanyProfileWidgetReviewsClick,
                            children: t("{companyReviewsCount} reviews", {
                              companyReviewsCount: overallRating.reviewCount.toString()
                            })
                          }
                        ) })
                      ] })
                    ]
                  }
                )
              ] })
            ] }) }) }),
            (Boolean(industry) || Boolean(companySize)) && /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
              Boolean(industry) && /* @__PURE__ */ jsx(Text, { size: "standard", icon: /* @__PURE__ */ jsx(IconCompany, {}), children: industry }),
              Boolean(companySize) && /* @__PURE__ */ jsx(Text, { size: "standard", icon: /* @__PURE__ */ jsx(IconPeople, {}), children: companySize })
            ] }) }),
            companyDescription && companyDescription.length > 0 && /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsx(
              ReadMore,
              {
                moreLabel: t("Show more"),
                lessLabel: t("Show less"),
                linesToPreview: 3,
                onShowMore: analytics.onCompanyProfileWidgetAccordionClick,
                children: /* @__PURE__ */ jsx(Stack, { space: "small", children: companyDescription.map((section, index) => /* @__PURE__ */ jsx(Box, { component: "p", children: section }, `companyDescription-${index}`)) })
              }
            ) })
          ] }),
          perksAndBenefits && perksAndBenefits.length > 0 && /* @__PURE__ */ jsx(Box, { paddingTop: "xlarge", children: /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
            /* @__PURE__ */ jsx(Text, { weight: "strong", children: t("Perks and benefits") }),
            /* @__PURE__ */ jsx(Inline, { space: "medium", collapseBelow: "tablet", children: perksAndBenefits.map((perk, index) => /* @__PURE__ */ jsx(
              Text,
              {
                size: "standard",
                icon: /* @__PURE__ */ jsx(IconPromote, { tone: "neutral" }),
                children: perk
              },
              `${perk}-${index}`
            )) })
          ] }) }) }),
          Boolean(profileUrl) && /* @__PURE__ */ jsx(Box, { paddingTop: "xlarge", children: /* @__PURE__ */ jsx(Actions, { children: /* @__PURE__ */ jsx(
            ButtonLink,
            {
              href: profileUrl,
              onClick: analytics.onCompanyProfileWidgetClick,
              data: { automation: "company-profile-profile-link" },
              icon: /* @__PURE__ */ jsx(IconArrow, { direction: "right" }),
              iconPosition: "trailing",
              children: t("More about this company")
            }
          ) }) })
        ]
      }
    )
  ] }) });
};
function useContactMatchInteractionEvents(ref, track) {
  const createHandler = useCallback(
    (eventType, contactType) => () => {
      track({
        contactType,
        eventType
      });
    },
    [track]
  );
  useEffect(() => {
    if (ref === null) {
      return;
    }
    const mappedEvents = [];
    const callback = (contactType, element) => {
      const clickHandler = createHandler("click", contactType);
      element.addEventListener("click", clickHandler);
      mappedEvents.push({ listener: clickHandler, type: "click", element });
      const copyHandler = createHandler("copy", contactType);
      element.addEventListener("copy", copyHandler);
      mappedEvents.push({ listener: copyHandler, type: "copy", element });
    };
    iterateOverContactMatches({ callback, DOMElement: ref });
    return () => {
      mappedEvents.forEach(({ element, type, listener }) => {
        element.removeEventListener(type, listener);
      });
    };
  }, [ref, createHandler]);
}
const JobDescription = (props) => {
  const {
    contactMatches,
    description,
    onContactMatchImpression,
    onContactMatchInteraction
  } = props;
  const [containerEl, setContainerEl] = useState(null);
  const renderedDesc = useMemo(() => {
    const view = templateRenderer();
    return view(description, contactMatches);
  }, [description, contactMatches]);
  useEffect(() => {
    if (!containerEl) {
      return;
    }
    const value = toCISImpression({ contactMatches });
    onContactMatchImpression(value);
  }, [containerEl]);
  useContactMatchInteractionEvents(containerEl, onContactMatchInteraction);
  return /* @__PURE__ */ jsx("div", { "data-automation": "jobAdDetails", ref: setContainerEl, children: /* @__PURE__ */ jsx(UnsafeJobHtmlRenderer, { children: renderedDesc }) });
};
const JobLocation = ({
  location
}) => /* @__PURE__ */ jsx(
  Text,
  {
    size: "small",
    icon: /* @__PURE__ */ jsx(IconLocation, { tone: "secondary" }),
    data: { automation: "job-detail-location" },
    children: location
  }
);
const JobClassifications = ({
  classifications
}) => /* @__PURE__ */ jsx(
  Text,
  {
    size: "small",
    icon: /* @__PURE__ */ jsx(IconCompany, { tone: "secondary" }),
    data: { automation: "job-detail-classifications" },
    children: classifications.map((classification, index) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
      classification,
      index < classifications.length - 1 && /* @__PURE__ */ jsx("br", {})
    ] }, `${classification}_${index}`))
  }
);
const JobWorkType = ({
  workType
}) => /* @__PURE__ */ jsx(
  Text,
  {
    size: "small",
    icon: /* @__PURE__ */ jsx(IconTime, { tone: "secondary" }),
    data: { automation: "job-detail-work-type" },
    children: workType
  }
);
const JobSalary = ({
  salary,
  currencyLabel,
  isSalaryMatch,
  isSignedIn,
  salaryExpectation,
  isCandidateSetSalary,
  salaryMatchCountryName,
  salaryTransparencyEnabled
}) => {
  if (salaryTransparencyEnabled) {
    return /* @__PURE__ */ jsx(
      JobSalaryWithSalaryTransparency,
      {
        salary,
        currencyLabel,
        isSalaryMatch,
        salaryExpectation,
        isCandidateSetSalary,
        isSignedIn,
        salaryMatchCountryName
      }
    );
  }
  return salary && /* @__PURE__ */ jsx(
    JobSalaryWithoutSalaryTransparency,
    {
      salary,
      currencyLabel
    }
  );
};
const JobSalaryWithoutSalaryTransparency = ({
  salary,
  currencyLabel
}) => {
  const formattedSalary = currencyLabel ? `${salary} (${currencyLabel})` : salary;
  return /* @__PURE__ */ jsx(
    Text,
    {
      icon: /* @__PURE__ */ jsx(IconMoney, { tone: "secondary" }),
      data: { automation: "job-detail-salary" },
      size: "small",
      children: formattedSalary
    }
  );
};
const JobSalaryWithSalaryTransparency = ({
  salary,
  currencyLabel,
  isSalaryMatch,
  isSignedIn,
  salaryExpectation,
  isCandidateSetSalary,
  salaryMatchCountryName
}) => isSignedIn ? /* @__PURE__ */ jsx(
  JobSalarySignedIn,
  {
    salary,
    currencyLabel,
    isSalaryMatch,
    salaryExpectation,
    isCandidateSetSalary,
    salaryMatchCountryName
  }
) : /* @__PURE__ */ jsx(JobSalarySignedOut, { salary, currencyLabel });
const JobSalarySignedIn = ({
  salary,
  currencyLabel,
  isSalaryMatch,
  salaryExpectation,
  isCandidateSetSalary,
  salaryMatchCountryName
}) => {
  if (isSalaryMatch) {
    return /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
      salary ? /* @__PURE__ */ jsx(FormattedSalary, { salary, currencyLabel }) : null,
      /* @__PURE__ */ jsx(
        SalaryTransparencyBadge,
        {
          salary,
          salaryExpectation,
          salaryMatchCountryName
        }
      )
    ] });
  }
  if (!salary) {
    if (!isCandidateSetSalary) {
      return /* @__PURE__ */ jsx(AddExpectedSalary, {});
    }
  }
  return salary && /* @__PURE__ */ jsx(FormattedSalary, { salary, currencyLabel });
};
const JobSalarySignedOut = ({ salary, currencyLabel }) => {
  if (!salary) {
    return /* @__PURE__ */ jsx(AddExpectedSalary, {});
  }
  return /* @__PURE__ */ jsx(FormattedSalary, { salary, currencyLabel });
};
const SalaryTransparencyBadge = ({
  salary,
  salaryExpectation,
  salaryMatchCountryName
}) => {
  const { onAnalyticsEvent } = useJobDetailsViewContext();
  const [iconInfoPopup, setIconInfoPopup] = useState(false);
  const { t } = useTranslations(translations$1);
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Inline, { space: "xsmall", alignY: "center", children: [
      salary ? /* @__PURE__ */ jsx(Box, { marginLeft: "medium", paddingLeft: "xsmall", children: /* @__PURE__ */ jsx(
        Text,
        {
          weight: "strong",
          tone: "positive",
          size: "xsmall",
          data: { automation: "job-detail-salary-match" },
          children: t("Profile salary match")
        }
      ) }) : /* @__PURE__ */ jsx(
        Text,
        {
          size: "small",
          tone: "positive",
          icon: /* @__PURE__ */ jsx(IconMoney, { tone: "secondary" }),
          data: { automation: "job-detail-salary-match" },
          children: t("Profile salary match")
        }
      ),
      /* @__PURE__ */ jsx(
        ButtonIcon,
        {
          variant: "transparent",
          label: t("Salary match details"),
          id: "salaryMatchDetails",
          icon: /* @__PURE__ */ jsx(IconInfo, { tone: "positive" }),
          onClick: () => {
            setIconInfoPopup(true);
            analytics.onSalaryBadgeClicked();
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      SalaryMatchDetailsPopup,
      {
        salary,
        salaryExpectation,
        salaryMatchCountryName,
        iconInfoPopup,
        setIconInfoPopup
      }
    )
  ] });
};
const SalaryMatchDetailsPopup = ({
  salary,
  salaryExpectation,
  salaryMatchCountryName,
  iconInfoPopup,
  setIconInfoPopup
}) => {
  const { t } = useTranslations(translations$1);
  const salaryMatchDetails = salary ? t(
    "This job's salary range matches the expected salary you've set in your profile."
  ) : t(
    "The employer has chosen not to show the salary. This job's salary range matches the expected salary you've set in your profile."
  );
  return iconInfoPopup ? /* @__PURE__ */ jsxs(
    Dialog,
    {
      open: iconInfoPopup,
      onClose: () => setIconInfoPopup(false),
      id: "salaryMatchDetails",
      title: t("Salary match details"),
      children: [
        /* @__PURE__ */ jsxs(Text, { children: [
          " ",
          salaryMatchDetails,
          " "
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
          /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
            /* @__PURE__ */ jsx(Text, { weight: "medium", children: t("Salary expectation") }),
            salary ? /* @__PURE__ */ jsx(Text, { children: t("Edit in profile") }) : null
          ] }) }),
          /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
            /* @__PURE__ */ jsx(Text, { tone: "secondary", size: "small", children: salaryMatchCountryName }),
            /* @__PURE__ */ jsx(Text, { tone: "secondary", children: salaryExpectation })
          ] }) })
        ] })
      ]
    }
  ) : null;
};
const FormattedSalary = ({ salary, currencyLabel }) => {
  const formattedSalary = currencyLabel ? `${salary} (${currencyLabel})` : salary;
  return /* @__PURE__ */ jsx(
    Text,
    {
      size: "small",
      icon: /* @__PURE__ */ jsx(IconMoney, { tone: "secondary" }),
      data: { automation: "job-detail-salary" },
      children: formattedSalary
    }
  );
};
const AddExpectedSalary = () => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(
    Text,
    {
      size: "small",
      tone: "secondary",
      icon: /* @__PURE__ */ jsx(IconMoney, { tone: "secondary" }),
      data: { automation: "job-detail-add-expected-salary" },
      children: t("Add expected salary to your profile for insights")
    }
  );
};
const PostedDate = () => {
  const { job } = useJobDetailsViewContext();
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(Text, { size: "small", tone: "secondary", children: t("Posted {jobPostedDate}", {
    jobPostedDate: job.postedDateFormatted || ""
  }) });
};
const JobDetailsViewHeaderAdditional = () => {
  const { job, salaryTransparencyEnabled } = useJobDetailsViewContext();
  return /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      job.location ? /* @__PURE__ */ jsx(JobLocation, { location: job.location }) : null,
      job.classifications ? /* @__PURE__ */ jsx(JobClassifications, { classifications: job.classifications }) : null,
      job.workType ? /* @__PURE__ */ jsx(JobWorkType, { workType: job.workType }) : null,
      /* @__PURE__ */ jsx(
        JobSalary,
        {
          salary: job.salary,
          currencyLabel: job.currencyLabel,
          isSalaryMatch: job.isSalaryMatch,
          isSignedIn: job.isSignedIn,
          salaryExpectation: job.salaryExpectation,
          isCandidateSetSalary: job.isCandidateSetSalary,
          salaryMatchCountryName: job.salaryMatchCountryName,
          salaryTransparencyEnabled
        }
      )
    ] }),
    /* @__PURE__ */ jsx(PostedDate, {})
  ] });
};
const iconForTone = {
  promote: IconRecommended,
  positive: IconTick,
  critical: IconCritical
};
const backgroundForTone = {
  promote: "promoteLight",
  positive: "positiveLight",
  critical: "criticalLight"
};
const JobStatusBadgeView = ({
  tooltip,
  label,
  tone,
  onImpression,
  onClickAnalytics,
  id
}) => {
  const trackClick = useCallback(() => {
    if (onClickAnalytics) {
      onClickAnalytics();
    }
  }, [onClickAnalytics]);
  const background = backgroundForTone[tone];
  const Icon = iconForTone[tone];
  useEffect(() => {
    if (onImpression) {
      onImpression();
    }
  }, [onImpression]);
  const badge = /* @__PURE__ */ jsx(
    Box,
    {
      display: "inlineBlock",
      borderRadius: "standard",
      background,
      padding: "xsmall",
      id,
      children: /* @__PURE__ */ jsx(
        Text,
        {
          size: "xsmall",
          weight: "medium",
          icon: /* @__PURE__ */ jsx(Icon, {}),
          data: { testid: "job-status-badge" },
          children: label
        }
      )
    }
  );
  return Boolean(tooltip) ? /* @__PURE__ */ jsx(
    TooltipRenderer,
    {
      id: `job-status-${id}-tooltip`,
      tooltip: /* @__PURE__ */ jsx(Text, { children: tooltip }),
      children: ({ triggerProps }) => /* @__PURE__ */ jsx(
        Box,
        {
          display: "inlineBlock",
          cursor: "pointer",
          onClick: onClickAnalytics ? trackClick : void 0,
          ...triggerProps,
          children: badge
        }
      )
    }
  ) : badge;
};
const hasBadge = (job) => job.isExpired || job.appliedDateFormatted || job.topApplicant;
const JobStatusBadge = () => {
  const { job, onAnalyticsEvent } = useJobDetailsViewContext();
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  const { t } = useTranslations(translations$2);
  if (job.isExpired) {
    return /* @__PURE__ */ jsx(
      JobStatusBadgeView,
      {
        id: "expired",
        label: t("This job is no longer available"),
        tone: "critical"
      }
    );
  }
  if (job.appliedDateFormatted) {
    return /* @__PURE__ */ jsx(
      JobStatusBadgeView,
      {
        id: "applied",
        label: t(`You've applied on <JobAppliedDate>`, {
          JobAppliedDate: () => job.appliedDateFormatted
        }),
        tone: "positive"
      }
    );
  }
  if (job.topApplicant) {
    return /* @__PURE__ */ jsx(
      JobStatusBadgeView,
      {
        label: job.topApplicant.label,
        tone: "promote",
        id: "topApplicant",
        tooltip: job.topApplicant.description,
        onImpression: analytics.onTopApplicantBadgeImpression,
        onClickAnalytics: analytics.onTopApplicantBadgeClick
      }
    );
  }
  return null;
};
const useReasons = () => {
  const { t } = useTranslations(translations$3);
  return {
    UnableToApply: t("Unable to apply"),
    Fraudulent: t("Fraudulent"),
    Discrimination: t("Discrimination"),
    Misleading: t("Misleading"),
    Other: t("Other")
  };
};
const FORM_ID = "report-job-ad-form";
const MAX_COMMENT_LENTH = 400;
const INITIAL_FORM_VALUES = {
  email: "",
  reason: "",
  comment: ""
};
const { FormProvider } = createForm(FORM_ID);
const ReportJobAd = (props) => {
  const { t } = useTranslations(translations$3);
  const {
    handleReset,
    initialExpansion,
    isPDPAConsentRequired,
    isVerified,
    status = "initial",
    validationErrors,
    renderRelativePaths
  } = props;
  const [formVisible, setFormVisible] = useState(initialExpansion);
  const required = {
    getErrorMessage: ({ validatorProps: { requiredLabel = "" } }) => Promise.resolve(requiredLabel),
    test: ({ value }) => Boolean(value)
  };
  const requiredSelection = {
    getErrorMessage: ({ validatorProps: { requiredSelectionLabel = "" } }) => Promise.resolve(requiredSelectionLabel),
    test: ({ value }) => Boolean(value.length)
  };
  const email = useField({
    id: "email",
    form: FORM_ID,
    validators: [required, isEmail],
    validatorProps: {
      requiredLabel: t("We need an email address to get back to you.")
    }
  });
  const reason = useField({
    id: "reason",
    form: FORM_ID,
    validators: [requiredSelection],
    validatorProps: {
      requiredSelectionLabel: t("We need a reason for reporting this job.")
    }
  });
  const comment = useField({
    id: "comment",
    form: FORM_ID,
    validators: [maxLength, required],
    validatorProps: {
      max: MAX_COMMENT_LENTH,
      requiredLabel: t("This field is required")
    }
  });
  const reasons = useReasons();
  const onCancel = useCallback(() => {
    handleReset();
    setFormVisible(false);
  }, [handleReset, setFormVisible]);
  const emailInputRef = useRef(null);
  const reasonInputRef = useRef(null);
  const commentInputRef = useRef(null);
  const inputRefs = useMemo(
    () => ({
      email: emailInputRef,
      reason: reasonInputRef,
      comment: commentInputRef
    }),
    [emailInputRef, reasonInputRef, commentInputRef]
  );
  useEffect(() => {
    validationErrors.some((errorKey) => {
      const inputRef = inputRefs[errorKey];
      if (inputRef == null ? void 0 : inputRef.current) {
        inputRef.current.focus();
        return true;
      }
      return false;
    });
  }, [validationErrors, inputRefs]);
  const securityPrivacyPath = useMelwaysLink({
    path: "/security-privacy",
    product: "candidate",
    absolute: !renderRelativePaths
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(HiddenVisually, { children: /* @__PURE__ */ jsx("h2", { children: t("Report this job advert") }) }),
    /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(Text, { size: "large", weight: "medium", children: t("Be careful") }),
      /* @__PURE__ */ jsx(Text, { children: isVerified ? t(
        "Don’t provide your bank or credit card details when applying for jobs."
      ) : t(
        "This job ad has not been subjected to our hirer verification process..."
      ) }),
      /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
        TextLink,
        {
          href: securityPrivacyPath,
          rel: "nofollow",
          weight: "weak",
          hitArea: "large",
          children: t("Learn how to protect yourself")
        }
      ) }),
      status === "success" ? /* @__PURE__ */ jsx(Notice, { tone: "positive", children: /* @__PURE__ */ jsx(Text, { data: { automation: "report-job-ad-success-message" }, children: t(
        "Thank you. Your job report has been forwarded to our job quality team."
      ) }) }) : null,
      status === "error" ? /* @__PURE__ */ jsx(Notice, { tone: "critical", children: /* @__PURE__ */ jsx(Text, { data: { automation: "report-job-ad-error-message" }, children: t(
        "It looks like something went wrong and your report could not be sent."
      ) }) }) : null,
      status === "initial" ? /* @__PURE__ */ jsx(Hidden, { print: true, children: /* @__PURE__ */ jsx(Box, { marginTop: "small", children: /* @__PURE__ */ jsx(
        Disclosure,
        {
          id: "toggleReportJobAdForm",
          expandLabel: t("Report this job ad"),
          data: {
            automation: "report-job-ad-toggle"
          },
          space: "large",
          onToggle: setFormVisible,
          expanded: formVisible,
          children: /* @__PURE__ */ jsx(
            "form",
            {
              onSubmit: props.handleSubmit,
              "data-automation": "report-job-ad-form",
              children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
                /* @__PURE__ */ jsx(
                  TextField,
                  {
                    ref: emailInputRef,
                    value: email.value,
                    onChange: email.onChange,
                    message: email.errorMessage || void 0,
                    tone: !email.valid ? "critical" : void 0,
                    id: "email",
                    label: t("Your email address"),
                    data: { automation: "report-job-ad-email" }
                  }
                ),
                /* @__PURE__ */ jsx(
                  Dropdown,
                  {
                    id: "reason",
                    label: t("Reason for reporting job"),
                    ref: reasonInputRef,
                    placeholder: t("Please select"),
                    data: { automation: "report-job-ad-reason" },
                    value: reason.value,
                    onChange: reason.onChange,
                    message: reason.errorMessage || void 0,
                    tone: !reason.valid ? "critical" : void 0,
                    children: Object.entries(reasons).map(([key, value]) => /* @__PURE__ */ jsx("option", { value: key, children: value }, key))
                  }
                ),
                /* @__PURE__ */ jsx(
                  Textarea,
                  {
                    id: "comment",
                    ref: commentInputRef,
                    label: t("Additional comments"),
                    data: { automation: "report-job-ad-comment" },
                    value: comment.value,
                    onChange: comment.onChange,
                    message: comment.errorMessage || void 0,
                    tone: !comment.valid ? "critical" : void 0,
                    characterLimit: MAX_COMMENT_LENTH
                  }
                ),
                isPDPAConsentRequired ? /* @__PURE__ */ jsx(
                  Text,
                  {
                    data: {
                      automation: "report-job-ad-pdpa-consent-label"
                    },
                    children: t(
                      "You confirm that you’re at least 20 years old or have parental consent for JobsDB and affiliates to process your personal data. By submitting this information, you agree to our Privacy Policy.",
                      {
                        TextLink: (children) => /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            href: "/privacy",
                            rel: "nofollow",
                            weight: "weak",
                            hitArea: "large",
                            children
                          }
                        )
                      }
                    )
                  }
                ) : null,
                /* @__PURE__ */ jsxs(Actions, { children: [
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "submit",
                      tone: "formAccent",
                      data: {
                        automation: "report-job-ad-submit"
                      },
                      children: t("Report job")
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      data: {
                        automation: "report-job-ad-cancel"
                      },
                      onClick: onCancel,
                      variant: "transparent",
                      tone: "formAccent",
                      children: t("Cancel")
                    }
                  )
                ] })
              ] })
            }
          )
        }
      ) }) }) : null
    ] })
  ] });
};
const ReportJobAd$1 = (props) => {
  const {
    initialExpansion = false,
    initialStatus = "initial",
    initialValues = INITIAL_FORM_VALUES,
    isPDPAConsentRequired,
    isVerified,
    onSubmit,
    renderRelativePaths
  } = props;
  const { language = "en" } = useLanguage();
  const [status, setStatus] = useState(initialStatus);
  const [validationErrors, setValidationErrors] = useState([]);
  const submitHandler = useCallback(
    (values) => {
      onSubmit(values).then((success) => {
        setStatus(success ? "success" : "error");
      }).catch(() => setStatus("error"));
      return;
    },
    [onSubmit, setStatus]
  );
  const key = useMemo(() => JSON.stringify(initialValues), [initialValues]);
  return /* @__PURE__ */ jsx(
    FormProvider,
    {
      initialValues,
      language,
      onSubmitFail: (errors) => setValidationErrors(errors),
      children: ({ handleSubmit, resetForm }) => /* @__PURE__ */ jsx(
        ReportJobAd,
        {
          initialExpansion,
          handleReset: resetForm,
          handleSubmit: handleSubmit(submitHandler),
          status,
          validationErrors,
          isPDPAConsentRequired,
          isVerified,
          renderRelativePaths
        }
      )
    },
    key
  );
};
const noop = () => {
};
const SaveButton = ({ job, ctas, size = "standard" }) => {
  const { t } = useTranslations(translations$3);
  return job.isExpired || Boolean(job.appliedDateFormatted) ? null : /* @__PURE__ */ jsx(
    Button,
    {
      "aria-expanded": job.isSaved || false,
      onClick: (ctas == null ? void 0 : ctas.onToggleSaveJob) ?? noop,
      variant: "soft",
      tone: "formAccent",
      data: { testid: "jdv-savedjob" },
      "aria-label": job.isSaved ? t("Unsave {jobTitle} at {jobCompanyName}", {
        jobTitle: job.title,
        jobCompanyName: job.company.name
      }) : t("Save {jobTitle} at {jobCompanyName}", {
        jobTitle: job.title,
        jobCompanyName: job.company.name
      }),
      size,
      children: job.isSaved ? t("Unsave") : t("Save")
    }
  );
};
const JobDetailsViewBase = () => {
  var _a, _b, _c;
  const {
    careerInsights,
    ctas,
    embedded,
    hideJobLink,
    hideOpenInNewTab,
    isPDPAConsentRequired,
    job,
    jobUrlOpts,
    onAnalyticsEvent,
    renderRelativePaths,
    reportJobAdInitialValues,
    shouldOpenApplyInNewTab,
    stickApplyButtonOnDesktop,
    displayCompanyProfile,
    uniqueContainerValue
  } = useJobDetailsViewContext();
  const { t } = useTranslations(translations$3);
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  const { ref: trackedComponent } = useInView({
    onChange(inView) {
      if (inView) {
        analytics.onSourcrImpression();
      }
    },
    triggerOnce: true
  });
  const video = job.video ? /* @__PURE__ */ jsx(Hidden, { print: true, children: /* @__PURE__ */ jsx(ResponsiveEmbed, { url: job.video.link }) }) : null;
  const restrictedApplicationNotice = job.restrictedApplication.label ? /* @__PURE__ */ jsx(Alert, { tone: "caution", children: /* @__PURE__ */ jsx(Text, { children: job.restrictedApplication.label }) }) : void 0;
  const showCompanyProfile = displayCompanyProfile && job.companyProfile;
  const showCompanyInfo = job.company.tags && job.company.tags.length > 0;
  const companyInformation = /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    /* @__PURE__ */ jsx(Heading, { component: "h2", level: embedded ? "4" : "3", children: t("Company information") }),
    /* @__PURE__ */ jsx(
      Tiles,
      {
        space: "large",
        columns: {
          mobile: 1,
          tablet: 2
        },
        children: (_a = job.company.tags) == null ? void 0 : _a.map(({ key, value }) => /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
          /* @__PURE__ */ jsx(Text, { weight: "medium", children: key }),
          /* @__PURE__ */ jsx(Text, { children: value })
        ] }, `${key}`))
      }
    )
  ] }) });
  const badge = hasBadge(job) ? /* @__PURE__ */ jsx(JobStatusBadge, {}) : false;
  return /* @__PURE__ */ jsx(
    JDVLayout,
    {
      onAnalyticsEvent,
      jobUrl: !hideJobLink ? job.url : void 0,
      hideJobLink,
      jobTitle: job.title,
      id: job.id,
      jobUrlOpts,
      renderRelativePaths,
      companyName: job.company.name,
      embedded,
      stickApplyButtonOnDesktop,
      applyAction: /* @__PURE__ */ jsx(
        ApplyButton,
        {
          job,
          ctas,
          shouldOpenApplyInNewTab
        }
      ),
      saveAction: /* @__PURE__ */ jsx(SaveButton, { job, ctas }),
      restrictedApplicationNotice,
      branding: job.branding,
      badge,
      header: /* @__PURE__ */ jsx(JobDetailsViewHeader, {}),
      headerAdditional: /* @__PURE__ */ jsx(JobDetailsViewHeaderAdditional, {}),
      mainContent: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("section", { children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
          ((_b = job.video) == null ? void 0 : _b.position) === "TOP" && video,
          Boolean(job.description) && /* @__PURE__ */ jsx(
            JobDescription,
            {
              description: job.description,
              contactMatches: job.contactMatches,
              onContactMatchImpression: analytics.onContactMatchImpression,
              onContactMatchInteraction: analytics.onContactMatchInteraction
            }
          ),
          job.phoneNumber ? /* @__PURE__ */ jsx(Text, { children: t("For more information, contact us on {phoneNumber}.", {
            phoneNumber: job.phoneNumber,
            TextLink: (children) => /* @__PURE__ */ jsx(TextLink, { href: `tel:${children}`, weight: "weak", children })
          }) }) : void 0,
          ((_c = job.video) == null ? void 0 : _c.position) === "BOTTOM" && video
        ] }) }),
        showCompanyInfo && !showCompanyProfile && /* @__PURE__ */ jsx(Fragment, { children: companyInformation }),
        job.sourcr && /* @__PURE__ */ jsx("section", { ref: trackedComponent, children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
          /* @__PURE__ */ jsx(Heading, { component: "h2", level: embedded ? "4" : "3", children: t("About the recruiter") }),
          /* @__PURE__ */ jsx(
            Box,
            {
              boxShadow: "borderNeutralLight",
              borderRadius: "large",
              paddingX: ["small", "gutter", "large"],
              paddingY: ["gutter", "gutter", "large"],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              children: /* @__PURE__ */ jsx(
                "a",
                {
                  href: job.sourcr.profileUri,
                  onClick: analytics.onSourcrClicked,
                  "data-testid": "sourcr-profile",
                  rel: "noopener noreferrer",
                  target: "_blank",
                  children: /* @__PURE__ */ jsxs("picture", { children: [
                    /* @__PURE__ */ jsx(
                      "source",
                      {
                        media: `(max-width: ${breakpoints.tablet - 1}px)`,
                        srcSet: job.sourcr.imageMobileSrc
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "source",
                      {
                        media: `(min-width: ${breakpoints.tablet}px)`,
                        srcSet: job.sourcr.imageSrc
                      }
                    ),
                    /* @__PURE__ */ jsx("img", { className: sourcrImage, loading: "lazy" })
                  ] })
                }
              )
            }
          )
        ] }) }),
        Boolean(job.employerQuestions.length) && /* @__PURE__ */ jsx("section", { children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
          /* @__PURE__ */ jsx(Heading, { component: "h2", level: embedded ? "4" : "3", children: t("Employer questions") }),
          /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
            /* @__PURE__ */ jsx(Text, { children: t(
              "Your application will include the following questions:"
            ) }),
            /* @__PURE__ */ jsx(List, { space: "small", children: job.employerQuestions.map((question, index) => /* @__PURE__ */ jsx(Text, { children: question }, `${question}_${index}`)) })
          ] })
        ] }) }),
        showCompanyProfile && job.companyProfile && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Box, { component: "section", children: /* @__PURE__ */ jsx(
            CompanyProfile,
            {
              onAnalyticsEvent,
              ...job.companyProfile
            }
          ) }),
          showCompanyInfo && /* @__PURE__ */ jsx(Fragment, { children: companyInformation })
        ] }),
        (ctas == null ? void 0 : ctas.onReportJobAd) ? /* @__PURE__ */ jsx("section", { children: /* @__PURE__ */ jsx(
          ReportJobAd$1,
          {
            onSubmit: ctas.onReportJobAd,
            initialValues: reportJobAdInitialValues,
            isPDPAConsentRequired,
            isVerified: job.isVerified,
            renderRelativePaths
          }
        ) }) : null,
        Boolean(careerInsights) ? /* @__PURE__ */ jsx("section", { children: /* @__PURE__ */ jsx(
          Box,
          {
            boxShadow: "borderNeutralLight",
            borderRadius: "large",
            padding: ["gutter", "gutter", "xlarge"],
            style: { margin: "auto" },
            children: /* @__PURE__ */ jsx(Box, { style: { maxWidth: "100%", margin: "auto" }, children: careerInsights })
          }
        ) }) : null
      ] }),
      optionBar: !embedded && hideOpenInNewTab ? /* @__PURE__ */ jsx(ShareMenu, { job, onAnalyticsEvent, showText: true }) : null,
      menu: /* @__PURE__ */ jsx(ShareMenu, { job, onAnalyticsEvent }),
      uniqueContainerValue,
      hideOpenInNewTab
    }
  );
};
const JobDetailsView = (props) => /* @__PURE__ */ jsx(JobDetailsViewContextProvider, { ...props, children: /* @__PURE__ */ jsx(JobDetailsViewBase, {}) });
export {
  JobDetailsView,
  useAnalyticsHandlers,
  useJobDetailsViewContext
};
